import styled from "styled-components";
//let { innerHeight, innerWidth } = window

// const ksh42 = require("../../static/image/ksh42.png");

export const Container = styled.div`
    background-color:white;
    margin: 8px 8px;
    padding: 8px 8px;
    border: 1px solid lightgray;
    border-radius:8px;
    .time{
      color: grey;
      height:30px;
      margin: 18px 18px;
    }
    .slider-div{
      display: flex;
      flex-direction: row;
      height:30px;
      justify-content: space-between;
      margin-top: 10px;
      margin-right: 10px;
      .slider{
        width:85%;
        height:30px;
        
      }
    }
    .container{
        width:100%;
        height:100%;
    }

`
